"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _reducer = require("../../Cart/redux/reducer");
var _reducer2 = require("../../../astercore/identityService/redux/reducer");
// Redux: Root Reducer
var _default = exports.default = (0, _redux.combineReducers)({
  ..._reducer.cartOperationReducer,
  ..._reducer2.commonServiceDataReducer
});